import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Select from 'react-select';

const BookingSummary = (props) => {
    const [allData, setAllData] = useState([]);
    const [loading, setLoading] = useState(true);

    const [selectedYear, setSelectedYear] = useState('');
    const [selectedMonth, setSelectedMonth] = useState('');

    const [totalBookings, setTotalBookings] = useState(0);
    const [shiftMorning22, setShiftMorning22] = useState(0);
    const [shiftNight22, setShiftNight22] = useState(0);
    const [shiftMorning10, setShiftMorning10] = useState(0);
    const [shiftNight10, setShiftNight10] = useState(0);
    const [regularBookings, setRegularBookings] = useState(0);
    const [newBookings, setNewBookings] = useState(0);
    const [managementBookings, setManagementBookings] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [averageAmount, setAverageAmount] = useState(0);
    const [regularCustomersList, setRegularCustomersList] = useState([]);
    const [hasSearched, setHasSearched] = useState(false);

    const yearOptions = [
        { value: 2024, label: '2024' },
        { value: 2025, label: '2025' },
        { value: 2026, label: '2026' },
        { value: 2027, label: '2027' },
        { value: 2028, label: '2028' },
        { value: 2029, label: '2029' },
        { value: 2030, label: '2030' },
    ];

    const monthOptions = [
        { value: 'January', label: 'January' },
        { value: 'February', label: 'February' },
        { value: 'March', label: 'March' },
        { value: 'April', label: 'April' },
        { value: 'May', label: 'May' },
        { value: 'June', label: 'June' },
        { value: 'July', label: 'July' },
        { value: 'August', label: 'August' },
        { value: 'September', label: 'September' },
        { value: 'October', label: 'October' },
        { value: 'November', label: 'November' },
        { value: 'December', label: 'December' }
    ];

    useEffect(() => {
        const fetchData = async () => {
            try {
                const url = process.env.REACT_APP_APIURL + "Booking/GetALLBookings?companyid=" + props.companyid;
                const response = await axios.get(url);
                setAllData(response.data);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching data: ", error);
                setLoading(false);
            }
        };

        fetchData();
    }, [props.companyid]);

    useEffect(() => {
        if (selectedYear && selectedMonth && allData.length > 0) {
            analyzeData();
            setHasSearched(true);
        } else {
            setHasSearched(false);
        }
    }, [selectedYear, selectedMonth, allData]);

    const analyzeData = () => {
        // 1. Calculate global phone frequencies for identifying Old vs New customers
        const globalPhoneCounts = {};
        allData.forEach(item => {
            if (item.ismanagementbooking === true) return;
            const phone = String(item.phone || '').replace(/\D/g, '');
            if (phone) {
                globalPhoneCounts[phone] = (globalPhoneCounts[phone] || 0) + 1;
            }
        });

        // 2. Filter by selected Year and Month
        const filtered = allData.filter(item => {
            if (!item.bookingdate) return false;
            const date = new Date(item.bookingdate);
            return date.getFullYear() === selectedYear && date.toLocaleString('default', { month: 'long' }) === selectedMonth;
        });

        // 3. Categorize into Old (Regular) and New
        let regularCount = 0;
        let newCount = 0;
        let sm22 = 0, sn22 = 0, sm10 = 0, sn10 = 0;
        let mgmtCount = 0;
        let totalAmt = 0;
        let countWithAmt = 0;
        const regularCustomersMap = {};
        let totalCountCalculated = 0;

        filtered.forEach(item => {
            const sName = (item.shiftName || '').toLowerCase();
            
            // Weight logic: 22h shifts count double
            let weight = sName.includes('22') ? 2 : 1;

            if (item.ismanagementbooking === true) {
                mgmtCount += weight;
                return;
            }

            let bookingAmt = parseFloat(item.amount) || 0;
            totalAmt += bookingAmt;
            if (bookingAmt > 0) {
                countWithAmt += 1;
            }

            const phone = String(item.phone || '').replace(/\D/g, '');
            if (!phone) return;

            const globalCount = globalPhoneCounts[phone] || 0;
            
            totalCountCalculated += weight;

            // If they have >= 2 bookings OVERALL, they are a regular/old customer
            if (globalCount >= 2) {
                regularCount += weight;
                if (!regularCustomersMap[phone]) {
                    regularCustomersMap[phone] = {
                        name: item.cusName || 'N/A',
                        phone: item.phone,
                        globalTotal: globalCount,
                        monthBookings: 1
                    };
                } else {
                    regularCustomersMap[phone].monthBookings++;
                }
            } else {
                // If they only have 1 booking overall (which is this one), they are a new customer
                newCount += weight;
            }

            // Shift breakdown
            if (sName.includes('morning') && sName.includes('22')) sm22++;
            else if (sName.includes('night') && sName.includes('22')) sn22++;
            else if (sName.includes('morning') && sName.includes('10')) sm10++;
            else if (sName.includes('night') && sName.includes('10')) sn10++;
        });

        const regularList = Object.values(regularCustomersMap).sort((a, b) => b.globalTotal - a.globalTotal);

        let avgAmt = countWithAmt > 0 ? (totalAmt / countWithAmt) : 0;

        setTotalBookings(totalCountCalculated);
        setTotalAmount(totalAmt);
        setAverageAmount(avgAmt);
        setShiftMorning22(sm22);
        setShiftNight22(sn22);
        setShiftMorning10(sm10);
        setShiftNight10(sn10);
        setRegularBookings(regularCount);
        setNewBookings(newCount);
        setManagementBookings(mgmtCount);
        setRegularCustomersList(regularList);
    };

    const handleCopyPhone = (phone) => {
        navigator.clipboard.writeText(phone);
    };

    return (
        <div className="container-fluid" style={{ padding: '30px', maxWidth: '1400px' }}>
            <style>{`
                .booking-summary-header h3 {
                    color: #ffffff !important;
                }
            `}</style>
            <div className="card shadow-sm border-0" style={{ borderRadius: '12px', overflow: 'hidden', marginBottom: '30px' }}>
                <div className="card-header booking-summary-header border-0 d-flex justify-content-between align-items-center" style={{ background: 'linear-gradient(135deg, #1d3641 0%, #0f172a 100%)', padding: '20px 30px' }}>
                    <h3 className="mb-0 text-white" style={{ fontWeight: '700', fontSize: '22px', letterSpacing: '0.5px' }}>
                        <i className="fas fa-chart-pie me-2 text-warning"></i> Booking Summary Report
                    </h3>
                </div>

                <div className="card-body" style={{ padding: '30px', backgroundColor: '#f8fafc' }}>
                    {loading ? (
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <h5 className="mt-3 text-muted">Loading Data...</h5>
                        </div>
                    ) : (
                        <>
                            <div className="row mb-5 align-items-end">
                                <div className="col-md-4 col-lg-3 mb-3 mb-md-0">
                                    <label className="form-label" style={{ fontWeight: '600', color: '#334155' }}>Select Year</label>
                                    <Select
                                        options={yearOptions}
                                        value={yearOptions.find(option => option.value === selectedYear)}
                                        onChange={(e) => setSelectedYear(e.value)}
                                        placeholder="Choose Year..."
                                    />
                                </div>
                                <div className="col-md-4 col-lg-3 mb-3 mb-md-0">
                                    <label className="form-label" style={{ fontWeight: '600', color: '#334155' }}>Select Month</label>
                                    <Select
                                        options={monthOptions}
                                        value={monthOptions.find(option => option.value === selectedMonth)}
                                        onChange={(e) => setSelectedMonth(e.value)}
                                        placeholder="Choose Month..."
                                    />
                                </div>
                            </div>

                            {hasSearched ? (
                                <>
                                    <div className="card shadow-sm border-0 mb-5" style={{ borderRadius: '16px', overflow: 'hidden', backgroundColor: '#ffffff', border: '1px solid #e2e8f0' }}>
                                        <div className="row g-0">
                                            
                                            {/* LEFT PANEL: Total Bookings */}
                                            <div className="col-md-4 d-flex flex-column justify-content-center p-5 border-end" style={{ borderColor: '#e2e8f0', background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)', color: 'white' }}>
                                                <div className="text-center mb-4">
                                                    <h2 className="text-uppercase mb-3" style={{ fontWeight: '800', letterSpacing: '2px', color: '#cbd5e1' }}>Total Bookings</h2>
                                                    <h1 className="mb-0 text-white" style={{ fontSize: '120px', fontWeight: '900', lineHeight: '1' }}>{totalBookings}</h1>
                                                </div>
                                                
                                                <div className="w-100 pt-4" style={{ borderTop: '1px solid rgba(255,255,255,0.1)' }}>
                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <span style={{ fontSize: '13px', fontWeight: '700', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '1px' }}>Total Amount</span>
                                                        <span style={{ fontSize: '18px', fontWeight: '800', color: '#f8fafc' }}>
                                                            Rs. {totalAmount.toLocaleString()}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <span style={{ fontSize: '13px', fontWeight: '700', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '1px' }}>Avg Amount</span>
                                                        <span style={{ fontSize: '18px', fontWeight: '800', color: '#f8fafc' }}>
                                                            {averageAmount > 0 ? `Rs. ${averageAmount.toLocaleString(undefined, { maximumFractionDigits: 0 })}` : 'N/A'}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* RIGHT PANEL */}
                                            <div className="col-md-8 d-flex flex-column">
                                                
                                                {/* Top Half: New, Regular, Management */}
                                                <div className="row g-0 flex-grow-1 border-bottom" style={{ borderColor: '#e2e8f0' }}>
                                                    <div className="col-4 d-flex flex-column justify-content-center align-items-center p-4 border-end" style={{ borderColor: '#e2e8f0', background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)' }}>
                                                        <h5 className="text-uppercase mb-2 text-center" style={{ fontWeight: '800', color: '#047857', letterSpacing: '1px', fontSize: '13px' }}>New Customer Bookings</h5>
                                                        <h2 className="mb-0" style={{ fontSize: '64px', fontWeight: '900', color: '#064e3b' }}>{newBookings}</h2>
                                                    </div>
                                                    <div className="col-4 d-flex flex-column justify-content-center align-items-center p-4 border-end" style={{ borderColor: '#e2e8f0', background: 'linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)' }}>
                                                        <h5 className="text-uppercase mb-2 text-center" style={{ fontWeight: '800', color: '#b45309', letterSpacing: '1px', fontSize: '13px' }}>Regular Customer Bookings</h5>
                                                        <h2 className="mb-0" style={{ fontSize: '64px', fontWeight: '900', color: '#78350f' }}>{regularBookings}</h2>
                                                    </div>
                                                    <div className="col-4 d-flex flex-column justify-content-center align-items-center p-4" style={{ background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)' }}>
                                                        <h5 className="text-uppercase mb-2 text-center" style={{ fontWeight: '800', color: '#475569', letterSpacing: '1px', fontSize: '13px' }}>Management Bookings</h5>
                                                        <h2 className="mb-0" style={{ fontSize: '64px', fontWeight: '900', color: '#0f172a' }}>{managementBookings}</h2>
                                                    </div>
                                                </div>

                                                {/* Bottom Half: Shifts */}
                                                <div className="row g-0 flex-grow-1">
                                                    {/* Morn 10H */}
                                                    <div className="col-3 d-flex flex-column justify-content-center align-items-center p-4 border-end" style={{ borderColor: '#e2e8f0', background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)' }}>
                                                        <h6 className="mb-2 text-center d-flex align-items-center justify-content-center" style={{ fontSize: '13px', fontWeight: '800', color: '#0284c7' }}><i className="fas fa-sun me-2" style={{ fontSize: '14px' }}></i> 10 hrs (Morning)</h6>
                                                        <h3 className="mb-0" style={{ fontWeight: '900', color: '#0369a1', fontSize: '64px' }}>{shiftMorning10}</h3>
                                                    </div>
                                                    {/* Night 10H */}
                                                    <div className="col-3 d-flex flex-column justify-content-center align-items-center p-4 border-end" style={{ borderColor: '#e2e8f0', background: 'linear-gradient(135deg, #faf5ff 0%, #f3e8ff 100%)' }}>
                                                        <h6 className="mb-2 text-center d-flex align-items-center justify-content-center" style={{ fontSize: '13px', fontWeight: '800', color: '#9333ea' }}><i className="fas fa-moon me-2" style={{ fontSize: '14px' }}></i> 10 hrs (Night)</h6>
                                                        <h3 className="mb-0" style={{ fontWeight: '900', color: '#7e22ce', fontSize: '64px' }}>{shiftNight10}</h3>
                                                    </div>
                                                    {/* Morn 22H */}
                                                    <div className="col-3 d-flex flex-column justify-content-center align-items-center p-4 border-end" style={{ borderColor: '#e2e8f0', background: 'linear-gradient(135deg, #fefce8 0%, #fef9c3 100%)' }}>
                                                        <h6 className="mb-2 text-center d-flex align-items-center justify-content-center" style={{ fontSize: '13px', fontWeight: '800', color: '#ca8a04' }}><i className="fas fa-sun me-2" style={{ fontSize: '14px' }}></i> 22 hrs (Morning)</h6>
                                                        <div className="d-flex align-items-baseline">
                                                            <h3 className="mb-0 me-2" style={{ fontWeight: '900', color: '#a16207', fontSize: '64px' }}>{shiftMorning22}</h3>
                                                            <span style={{ fontSize: '18px', fontWeight: '700', color: '#ca8a04' }}>({shiftMorning22 * 2})</span>
                                                        </div>
                                                    </div>
                                                    {/* Night 22H */}
                                                    <div className="col-3 d-flex flex-column justify-content-center align-items-center p-4" style={{ background: 'linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%)' }}>
                                                        <h6 className="mb-2 text-center d-flex align-items-center justify-content-center" style={{ fontSize: '13px', fontWeight: '800', color: '#4f46e5' }}><i className="fas fa-moon me-2" style={{ fontSize: '14px' }}></i> 22 hrs (Night)</h6>
                                                        <div className="d-flex align-items-baseline">
                                                            <h3 className="mb-0 me-2" style={{ fontWeight: '900', color: '#4338ca', fontSize: '64px' }}>{shiftNight22}</h3>
                                                            <span style={{ fontSize: '18px', fontWeight: '700', color: '#4f46e5' }}>({shiftNight22 * 2})</span>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    {regularCustomersList.length > 0 && (
                                        <div className="card shadow-sm border-0 mt-5" style={{ borderRadius: '12px', overflow: 'hidden' }}>
                                            <div className="card-header bg-white border-bottom py-3">
                                                <h5 className="mb-0 d-flex align-items-center" style={{ fontWeight: '700', color: '#1e293b' }}>
                                                    <i className="fas fa-star text-warning me-2"></i> Regular Customers Booking All The Time
                                                </h5>
                                            </div>
                                            <div className="card-body p-0">
                                                <div className="table-responsive" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                                                    <table className="table table-hover align-middle mb-0">
                                                        <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                                                            <tr style={{ background: '#f8fafc', color: '#475569' }}>
                                                                <th style={{ padding: '16px', fontSize: '13px', fontWeight: '700', textTransform: 'uppercase', borderBottom: '2px solid #e2e8f0' }} className="text-center">Rank</th>
                                                                <th style={{ padding: '16px', fontSize: '13px', fontWeight: '700', textTransform: 'uppercase', borderBottom: '2px solid #e2e8f0' }}>Customer Name</th>
                                                                <th style={{ padding: '16px', fontSize: '13px', fontWeight: '700', textTransform: 'uppercase', borderBottom: '2px solid #e2e8f0' }}>Phone Number</th>
                                                                <th style={{ padding: '16px', fontSize: '13px', fontWeight: '700', textTransform: 'uppercase', borderBottom: '2px solid #e2e8f0' }} className="text-center">Total Bookings (All Years)</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {regularCustomersList.map((item, index) => (
                                                                <tr key={index}>
                                                                    <td className="text-center" style={{ padding: '16px', borderBottom: '1px solid #f1f5f9' }}>
                                                                        {index === 0 && (
                                                                            <span style={{ background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', color: 'white', padding: '6px 14px', borderRadius: '6px', fontWeight: '800', fontSize: '14px', boxShadow: '0 2px 6px rgba(245, 158, 11, 0.4)' }}>
                                                                                #1 👑
                                                                            </span>
                                                                        )}
                                                                        {index === 1 && (
                                                                            <span style={{ background: 'linear-gradient(135deg, #64748b 0%, #475569 100%)', color: 'white', padding: '6px 14px', borderRadius: '6px', fontWeight: '800', fontSize: '14px' }}>
                                                                                #2
                                                                            </span>
                                                                        )}
                                                                        {index === 2 && (
                                                                            <span style={{ background: 'linear-gradient(135deg, #d97706 0%, #b45309 100%)', color: 'white', padding: '6px 14px', borderRadius: '6px', fontWeight: '800', fontSize: '14px' }}>
                                                                                #3
                                                                            </span>
                                                                        )}
                                                                        {index > 2 && (
                                                                            <span style={{ background: '#e2e8f0', color: '#334155', padding: '6px 14px', borderRadius: '6px', fontWeight: '700', fontSize: '13px' }}>
                                                                                #{index + 1}
                                                                            </span>
                                                                        )}
                                                                    </td>
                                                                    <td style={{ padding: '16px', borderBottom: '1px solid #f1f5f9', fontWeight: '600', color: '#0f172a', fontSize: '15px' }}>
                                                                        {item.name}
                                                                    </td>
                                                                    <td style={{ padding: '16px', borderBottom: '1px solid #f1f5f9' }}>
                                                                        <span
                                                                            onClick={() => handleCopyPhone(item.phone)}
                                                                            title="Click to copy"
                                                                            style={{ cursor: 'pointer', background: '#f8fafc', padding: '6px 12px', borderRadius: '6px', border: '1px solid #e2e8f0', fontWeight: '600', color: '#334155', display: 'inline-flex', alignItems: 'center', gap: '6px' }}
                                                                        >
                                                                            {item.phone} <i className="far fa-copy text-muted"></i>
                                                                        </span>
                                                                    </td>
                                                                    <td className="text-center" style={{ padding: '16px', borderBottom: '1px solid #f1f5f9' }}>
                                                                        <span style={{ backgroundColor: '#10b981', color: 'white', fontWeight: '800', padding: '8px 20px', borderRadius: '25px', fontSize: '30px', boxShadow: '0 2px 6px rgba(16, 185, 129, 0.4)' }}>
                                                                            {item.globalTotal} <span style={{ fontSize: '16px', fontWeight: '600' }}>Bookings</span>
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {regularCustomersList.length === 0 && (totalBookings > 0 || managementBookings > 0) && (
                                        <div className="text-center py-5 bg-white rounded shadow-sm border mt-4" style={{ borderColor: '#e2e8f0' }}>
                                            <i className="fas fa-info-circle fa-3x mb-3 text-primary"></i>
                                            <h5 style={{ color: '#1e293b', fontWeight: '700' }}>No Regular Customers Found</h5>
                                            <p className="text-muted mb-0">All bookings for {selectedMonth} {selectedYear} were made by new customers or management.</p>
                                        </div>
                                    )}

                                    {totalBookings === 0 && managementBookings === 0 && (
                                        <div className="text-center py-5 bg-white rounded shadow-sm border mt-4" style={{ borderColor: '#e2e8f0' }}>
                                            <i className="far fa-folder-open fa-3x mb-3 text-muted"></i>
                                            <h5 style={{ color: '#1e293b', fontWeight: '700' }}>No Bookings Found</h5>
                                            <p className="text-muted mb-0">There are no bookings for {selectedMonth} {selectedYear}.</p>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <div className="text-center py-5 rounded" style={{ backgroundColor: '#ffffff', border: '1px dashed #cbd5e1' }}>
                                    <i className="fas fa-filter fa-3x mb-3 text-muted" style={{ opacity: 0.5 }}></i>
                                    <h5 style={{ color: '#475569', fontWeight: '600' }}>Select Year and Month</h5>
                                    <p className="text-muted mb-0">Please select a year and month to generate the booking summary.</p>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default BookingSummary;
